//Billingdetailspagecard
import React from 'react';
import { getMethod, postMethod } from '../../../services/apiService';
import { PAYPAL_URL, RAZORPAY_URL } from '../../../utility/config';
import LoadingSpinner from '../../../utility/LoadingSpinner';

function Billingdetailspagecard() {
  const [currency, setCurrency] = React.useState(null);
  console.log("----->", currency)

  const [loading, setLoading] = React.useState(false);
  const RAZORPAY_PAYMENT = RAZORPAY_URL
  const PAYPAL_PAYMENT = PAYPAL_URL

  // Get billing data from localStorage
  const billingData = JSON.parse(localStorage.getItem('billingData')) || {};
  const poemData = JSON.parse(localStorage.getItem('selectedPoem')) || {};


  const isFund = poemData.type === "fund";
  //Determine price and shipping
  const bookPrice = parseInt(poemData.price || 0, 10);
  const quantity = parseInt(billingData.quantity || '1', 10);
  const country = (billingData.country || '').toLowerCase();

  let shippingCharge = 0;
  if (!isFund) {
    if (country === 'india') {
      if (quantity === 1) {
        shippingCharge = 0;
      } else if (quantity >= 2 && quantity <= 5) {
        shippingCharge = 500;
      } else if (quantity >= 6 && quantity <= 10) {
        shippingCharge = 1000;
      }
    } else {
      if (quantity === 1) {
        shippingCharge = 2500;
      }
      else if (quantity >= 2 && quantity <= 10) {
        shippingCharge = 2500 + (500 * (quantity - 1));
      }
    }
  }

  // default to 1 if not set
  const totalBookPrice = (bookPrice * quantity)
  const totalPrice = totalBookPrice + shippingCharge;
  // const totalPrice = isFund ? price : totalBookPrice + shippingCharge;


  React.useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await getMethod('settings');
        console.log("sudfhj", response)
        if (response && response.status) {
          setCurrency(response.data.usd_to_inr)
        } else {
          console.error('Failed to fetch settings:', response.error || response);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);


  //Submit to backend - payment
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const paymentMethod = billingData.paymentMethod ?? 'razorpay';
      if (!billingData.name || !billingData.email || !billingData.phoneNumber || !totalPrice) {
        alert('Please fill in all required billing information.');
        return;
      }

      // let totalPriceUSD = totalPrice / currency;

      if (!currency) {
        alert('Currency conversion rate not loaded yet. Please try again.');
        setLoading(false);
        return;
      }

      // Convert INR to USD
      const totalPriceUSD = parseFloat((totalPrice / currency).toFixed(2));
      console.log("calculated amount", totalPriceUSD)

      const payload = {
        title: poemData?.title ?? "Poem Title",
        name: billingData.name ?? '',
        country: billingData.country ?? '',
        contact: (billingData.code ?? '') + (billingData.phoneNumber ?? ''),
        email: billingData.email ?? '',
        address: billingData.address ?? '',
        pincode: billingData.pincode ?? '',
        purchased_quantity: parseInt(billingData.quantity ?? '1', 10),
        amount: bookPrice,
        payment_id: null,
        item_type: isFund ? 'Fund' : 'Poem',
        item_id: poemData.id ?? 0,
        payment_method: paymentMethod.toLowerCase(),
        // total_price: totalPriceUSD,
        total_price: totalPriceUSD,
      };
      console.log("payment", payload)
      let response;
      let checkoutUrl;
      console.log(checkoutUrl)

      switch (paymentMethod.toLowerCase()) {
        case 'gpay':
        case 'razorpay':
          response = await postMethod(`${RAZORPAY_PAYMENT}`, payload);
          checkoutUrl = response?.checkout_url;
          break;

        case 'paypal':
          response = await postMethod(`${PAYPAL_PAYMENT}`, payload);
          console.log("paypal data", payload)
          checkoutUrl = response?.checkout_url;
          console.log("checkoutUrl data", response)
          break;

        default:
          alert('Invalid payment method selected.');
          return;
      }

      if (checkoutUrl) {
        console.log("checkoutUrl", checkoutUrl);
        window.location.href = checkoutUrl;
      } else {
        console.error('Payment error:', JSON.stringify(response, null, 2));
        alert('Failed to initiate payment. Please try again.');
      }

    } catch (error) {
      console.error('Payment error:', error);
      alert('An error occurred while connecting to the payment gateway.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="payment-page">
      <div className="billing-details-page">
        <h3>Billing Details Summary</h3>
        <div className="billing-details">
          <div>
            <label htmlFor="fullName">Full Name :</label>
            <span>{billingData.name}</span>
          </div>
          <div>
            <label htmlFor="phoneNumber">Phone Number :</label>
            <span>{billingData.code} {billingData.phoneNumber}</span>
          </div>
          <div>
            <label htmlFor="email">Email :</label>
            <span>{billingData.email}</span>
          </div>
          <div>
            <label htmlFor="address">Full Address :</label>
            <span>{billingData.address}</span>
          </div>
          {/* <div>
            <label>Country: </label>
            <span>{billingData.country}</span>
          </div>
          <div>
            <label>Book Price: </label>
            <span>₹{bookPrice}</span>
          </div>
          <div>
            <label>{isFund ? "Price" : "Quantity"}: </label>
            <span>{isFund ? poemData.price : quantity}</span>
          </div>
          <div>
            <label>Total Book Price: </label>
            <span>₹{totalBookPrice}</span>
          </div>
          <div>
            <label>Pincode: </label>
            <span>{billingData.pincode}</span>
          </div> */}

          {/* Fund : Poem */}
          {isFund ? (
            <div>
              <label>Fund Amount:</label>
              <span>₹ {poemData.price}</span>
            </div>
          ) : (
            <>
              <div>
                <label>Book Price:</label>
                <span>₹ {bookPrice}</span>
              </div>
              <div>
                <label>Quantity:</label>
                <span>{quantity}</span>
              </div>
              <div>
                <label>Total Book Price:</label>
                <span>₹ {totalBookPrice}</span>
              </div>
              <div>
                <label>Shipping Charges:</label>
                <span>₹ {shippingCharge === 0 ? 'Free Shipping' : `${shippingCharge}`}</span>
              </div>
            </>
          )}

          {/* <div style={{ display: "flex" }}>
            <label>Shipping Charges: </label>
            <span>{shippingCharge === 0 ? 'Free Shipping' : `${shippingCharge} INR`}</span>
          </div> */}
          <div style={{ fontWeight: 'bold' }}>
            <label>Total Price: </label>
            <span>₹ {totalPrice} </span>
          </div>
          <button onClick={handleSubmit} className="payment-submit-button" style={{ marginTop: 20 }}>
            {loading ? 'Processing...' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Billingdetailspagecard;